import { render, staticRenderFns } from "./tm-stripe-payment.vue?vue&type=template&id=3d72d1cd&"
import script from "./tm-stripe-payment.vue?vue&type=script&lang=ts&"
export * from "./tm-stripe-payment.vue?vue&type=script&lang=ts&"
import style0 from "./tm-stripe-payment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports